import React from "react";

import "./pageButton.scss";

const PageButton = ({
  disabled = false,
  filled,
  label,
  standardWidth,
  className = "",
}) => {
  return (
    <button
      disabled={disabled}
      className={`pageButton ${filled ? "filled" : "outlined"} ${className}`}
    >
      {label}
    </button>
  );
};

export default PageButton;
